var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiusButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 20.5,
    cy: 20.5,
    r: 20.5
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-32.9%",
    y: "-28.0%",
    width: "165.9%",
    height: "165.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.115930944 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Design---Position",
    transform: "translate(-280.000000, -482.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(287.179687, 491.640625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    transform: "translate(20.500000, 20.500000) rotate(-90.000000) translate(-20.500000, -20.500000) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#DDDDDD",
    strokeWidth: 2,
    fill: "#FFFFFF",
    fillRule: "evenodd",
    cx: 20.5,
    cy: 20.5,
    r: 21.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(20.000000, 20.000000) rotate(-90.000000) translate(-20.000000, -20.000000) translate(19.000000, 14.500000)",
    stroke: "#000000",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 0,
    x2: 1,
    y2: 11,
    id: "Line-Copy-2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiusButton);
export default __webpack_public_path__ + "static/media/mius-button.b5222fb1601a6a23517635c5aa9278fe.svg";
export { ForwardRef as ReactComponent };